<template>
  <div class="commodity-data-card">
    <div class="data-item" v-for="item in list" :key="item.title">
      <div class="item-top">
        <div class="item-left">
          <div class="title">
            <div
              class="title-icon"
              :style="{ boxShadow: `0px 3px 5px 0px ${item.shadowColor}` }"
            >
              <img :src="require('@/assets/' + item.icon)" alt="" />
            </div>
            <span class="title-text">{{ item.title }}</span>
          </div>
          <div class="value">{{ item.value || 0 }}</div>
        </div>
        <!-- <div class="item-right">
          <img :src="require('@/assets/' + item.icon)" alt="" />
        </div> -->
      </div>
      <div class="bottom">
        <div class="card-footer" v-show="name !== '较上段'">
          <span class="compare-label">{{ name }}：</span>
          <div class="trend-badge" :class="item.isUp ? 'up' : 'down'">
            <span class="trend-value">{{ item.compareValue }}%</span>
            <i
              :class="item.isUp ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "commodity-data-card",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "较上月",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.commodity-data-card {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;

  .data-item {
    min-width: 0;
    padding: 19px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: hidden;

    .item-top {
      min-width: 0;
      max-width: 100%;
      .item-left {
        min-width: 0;
        max-width: 100%;
        .title {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          display: flex;
          align-items: center;

          .title-icon {
            width: 28px;
            height: 28px;
            margin-right: 8px;
            background: transparent;
            border-radius: 8px 8px 8px 8px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              display: block; /* 消除图片默认 inline 状态下 baseline 基线对齐产生的底部空白白缝隙 Bug */
            }
          }

          .title-text {
            flex: 1;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .value {
          font-weight: bold;
          font-size: 26px;
          color: #000000;
          line-height: 32px;
          margin-top: 12px;
          white-space: nowrap;
        }
      }

      // .item-right {
      //   flex: 0 0 54px;
      //   width: 54px;
      //   height: 54px;
      //   margin-left: 12px;

      //   img {
      //     width: 100%;
      //     height: 100%;
      //   }
      // }
    }

    .bottom {
    }

    // 对比趋势
    .card-footer {
      display: flex;
      align-items: center;
      margin-top: 15px;
      font-size: 14px;
      font-family: "AlibabaPuHuiTi_2_55_Regular", sans-serif;
      min-width: 0;

      .compare-label {
        color: #666666;
        white-space: nowrap;
      }

      .trend-badge {
        display: flex;
        align-items: center;
        padding: 1px 8px;
        border-radius: 4px;
        gap: 2px;
        font-weight: 500;

        &.up {
          background: #e6f7ed;
          color: #16c064;
        }

        &.down {
          background: #fff1f0;
          color: #f5222d;
        }
      }
    }
  }
}

@media (max-width: 1600px) {
  .commodity-data-card {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

@media (max-width: 1440px) {
  .commodity-data-card {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
</style>
